import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePermissionsGroup } from "PFCore/services/admin/permissions_groups/delete_permissions_group";

import { adminKeys } from "./query_keys";

export const useDeletePermissionsGroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => deletePermissionsGroup(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: adminKeys.permissionsGroups() });
    }
  });
};
